module.exports = "../images/testimonials-bg.jpg?v=8b9830d";